type StockChipProps = {
  count: number;
  imageCount: number;
};
const StockChip = ({ count, imageCount }: StockChipProps) => {
  return count >= 1 && imageCount >= 5 ? (
    <span className="vehicle-status-chip vehicle-status-chip--stock vehicle-status-chip--stock-count ch-color--ac-black ch-fw--500 ch-fs--1 ch-display--flex ch-align-items--center">
      {count} in stock now
    </span>
  ) : (
    <span className="vehicle-status-chip vehicle-status-chip--stock ch-color--ac-black ch-fw--500 ch-fs--1">
      Ask about stock availability
    </span>
  );
};

export default StockChip;
